import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderQuoteService } from '../../services/order-quote.service';
import { ActivatedRoute } from '@angular/router';
import { OrderQuoteConfirmationDTO } from '../../interfaces/order-quote-confirmation';
import { switchMap } from 'rxjs/operators';
import { OrderQuoteDTO } from '../../interfaces/order-quote';
import { BankersRoundPipe } from '../../pipes/bankers-round.pipe';

@Component({
  selector: 'b2c-payment-confirmation',
  templateUrl: './b2c-payment-confirmation.component.html',
  styleUrls: ['./b2c-payment-confirmation.component.scss'],
})
export class B2cPaymentConfirmationComponent implements OnInit {
  @Input() quote: OrderQuoteDTO;

  public get yourQuotePriceWithVAT(): number {
    return this.bankersRoundPipe.transform(this.yourQuotePrice * 1.2, 2);
  }

  public get yourQuotePrice(): number {
    return this.quote.bookUrgent ? this.quote.urgentPrice : this.quote.standardPrice;
  }

  public get yourOriginalPrice(): number {
    return this.yourQuotePrice + this.discountAmount;
  }

  public get discountAmount(): number {
    return this.quote.bookUrgent
      ? this.quote.urgentDiscountAmount
      : this.quote.standardDiscountAmount;
  }

  public get showDiscountPrice(): boolean {
    return this.discountAmount > 0;
  }

  constructor(private bankersRoundPipe: BankersRoundPipe) {}

  ngOnInit() {}
}
